export const assetColumns = [
  {
    id: "name",
    label: "Name",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "id",
    label: "RepairShopr ID",
    editable: false,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "customer_id",
    label: "Customer ID",
    editable: false,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "customer_business_name",
    label: "Customer",
    editable: false,
    type: "text",
    width: "250",
    show: true,
    resizable: true,
  },
  {
    id: "contact_id",
    label: "Contact ID",
    editable: false,
    type: "number",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "asset_serial",
    label: "Asset Serial",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "asset_type",
    label: "Asset Type",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "make",
    label: "Make",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "model",
    label: "Model",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "warranty_start_date",
    label: "Warranty Start",
    editable: true,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "warranty_end_date",
    label: "Warranty End",
    editable: true,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "warranty_type",
    label: "Warranty Type",
    editable: true,
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "warranty",
    label: "Warranty",
    editable: true,
    type: "selection",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "service_tag",
    label: "Service Tag",
    editable: true,
    type: "text",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "created_at",
    label: "Created",
    editable: false,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
  {
    id: "updated_at",
    label: "Updated",
    editable: false,
    type: "date",
    width: "150",
    show: true,
    resizable: true,
  },
];
